module.exports = __webpack_public_path__ + "img/Two-step_verification.0a9c423c.svg";